<!-- @format -->

<div class="modal-header">
  <h2 class="modal-title">{{ values?.title }}</h2>
  <sis-modal-close-button />
</div>
<div class="modal-body">
  <p *ngIf="values?.message">{{ values.message }}</p>
  <sis-technical-message-view [title]="'COMMON.SHOW_ERROR_DETAILS' | translate" [message]="errorInfo" />
</div>
<div class="modal-footer">
  <sis-button (clicked)="refreshPage()" [hollow]="true">{{ "COMMON.REFRESH_PAGE" | translate }}</sis-button>
  <sis-button (clicked)="modal.dismiss()">{{ "COMMON.CLOSE_ERROR" | translate }}</sis-button>
</div>
